import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

// Requirement 4 & 5: Never redirect before auth check completes.
// Show a loader while loading === true, then redirect only when loading === false.
export default function ProtectedRoute({ children, requireRole = null }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Requirement 5: WAIT until auth resolves, do NOT redirect yet
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
        <div className="relative">
          <div className="w-16 h-16 border-4 border-blue-600/20 rounded-full animate-spin border-t-blue-600" />
          <div className="absolute inset-0 flex items-center justify-center">
            <img src="/logo 2.jpg" alt="Logo" className="w-8 h-8 rounded-full opacity-50" />
          </div>
        </div>
        <p className="mt-4 text-slate-500 font-medium animate-pulse">Verifying your session...</p>
      </div>
    );
  }

  // Requirement 3: Only redirect AFTER loading is done
  if (!user) {
    // Pick the right login destination based on which module the user was
    // trying to enter. Defaults to the Job Portal login as a catch-all.
    const path = location.pathname;
    let loginPath = "/jobs/auth";
    if (path.startsWith("/recruit")) loginPath = "/recruit/auth";
    else if (path.startsWith("/ats"))   loginPath = "/ats/login";
    else if (path.startsWith("/hrms"))  loginPath = "/hrms"; // HRMSApp self-manages auth
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // Role-based protection
  if (requireRole && user.role !== requireRole) {
    if (user.role === "jobseeker" && location.pathname.startsWith("/recruit")) {
      return <Navigate to="/jobs/dashboard" replace />;
    }
    if (user.role === "employer" && location.pathname.startsWith("/jobs/dashboard")) {
      return <Navigate to="/recruit/dashboard" replace />;
    }
  }

  return children;
}
